(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["whats-on"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function londonToday() {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(new Date());
    }

    function init(root) {
      var cards = Array.prototype.slice.call(root.querySelectorAll('.gs-card'));
      var grids = {
        live: root.querySelector('[data-grid="live"]'),
        upcoming: root.querySelector('[data-grid="upcoming"]')
      };
      var empties = {
        live: root.querySelector('[data-empty="live"]'),
        upcoming: root.querySelector('[data-empty="upcoming"]')
      };
      var buttons = Array.prototype.slice.call(root.querySelectorAll('.gs-filter'));
      var store = 'all';

      var param = new URLSearchParams(window.location.search).get('store');
      if (param === 'ancoats' || param === 'deansgate') store = param;

      function classify(card, today) {
        if (card.dataset.always === 'true') return 'live';
        var start = card.dataset.start;
        var end = card.dataset.end || start;
        if (!start) return 'upcoming';
        if (end < today) return 'ended';
        if (start <= today) return 'live';
        return 'upcoming';
      }

      function byStart(a, b) {
        var x = a.dataset.start || '9999-12-31';
        var y = b.dataset.start || '9999-12-31';
        return x < y ? -1 : x > y ? 1 : 0;
      }

      function render() {
        var today = londonToday();
        var buckets = { live: [], upcoming: [] };

        cards.forEach(function (card) {
          var state = classify(card, today);
          card.dataset.state = state;
          if (state === 'ended') { card.hidden = true; return; }
          buckets[state].push(card);
        });

        ['live', 'upcoming'].forEach(function (key) {
          buckets[key].sort(byStart).forEach(function (card) {
            grids[key].appendChild(card);
            var match = store === 'all' || card.dataset.store === 'both' || card.dataset.store === store;
            card.hidden = !match;
          });
          var visible = buckets[key].filter(function (c) { return !c.hidden; }).length;
          grids[key].hidden = visible === 0;
          if (empties[key]) empties[key].hidden = visible !== 0;
        });

        buttons.forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.filter === store));
        });
      }

      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          store = b.dataset.filter;
          var url = new URL(window.location.href);
          if (store === 'all') url.searchParams.delete('store');
          else url.searchParams.set('store', store);
          window.history.replaceState({}, '', url);
          render();
        });
      });

      render();
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) render();
      });
    }

    function boot() {
      document.querySelectorAll('[data-whatson]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
